import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PolaznikUcioniceService {

  headers = new Headers();

  constructor(private _http: Http) { }

  dohvatiDetalje(idkorisnik: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_popis_ucionica_za_jednog_polaznika', idkorisnik)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznik-ucionice/polaznik-ucionice.service.ts